import { Box, SxProps, Theme, Typography } from "@mui/material";

import { ClinicianData } from "../features/data/patientApiSlice";
import GraphemeSplitter from "grapheme-splitter";
import React, { useState } from "react";
import { createStyleSheet } from "../utils/styles";
import { theme } from "../../theme";

const colors = [
  "#0498a0",
  "#076ba8",
  "#0a9114",
  "#570ba0",
  "#a5088f",
  "#ea2626",
  "#0707ff",
];

const ClinicianBadge = (props: {
  clinician: ClinicianData;
  sx?: SxProps<Theme>;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) => {
  const { clinician, sx, onClick } = props;
  const [imageError, setImageError] = useState(false);

  // Calculate initials and color (always calculate for fallback)
  const initials = Array.from(
    new GraphemeSplitter()
      .splitGraphemes(clinician.name)
      .reduce(
        (prev, curr) => {
          if (curr === " ") {
            prev.push("");
          } else {
            prev[prev.length - 1] += curr;
          }
          return prev;
        },
        [""]
      )
      .map((n) => Array.from(n)[0])
      .join("")
  )
    .slice(0, 2)
    .join("");
  const color =
    colors[
      Array.from(initials).reduce((sum, c) => sum + c.charCodeAt(0), 0) %
        colors.length
    ];

  return (
    <Box
      sx={
        {
          ...styles.badge,
          backgroundColor: color,
          ...sx,
        } as SxProps<Theme>
      }
      onClick={onClick}
    >
      {clinician.picture && !imageError ? (
        <Box
          component="img"
          src={clinician.picture}
          alt={clinician.name}
          onError={() => setImageError(true)}
          sx={{
            height: 32,
            objectFit: "contain",
            [theme.breakpoints.down("desktop")]: { height: 28 },
          }}
        />
      ) : (
        <Box sx={styles.textContainer}>
          <Typography variant="clinicianInitials">{initials}</Typography>
        </Box>
      )}
    </Box>
  );
};

const styles = createStyleSheet({
  badge: {
    borderRadius: "50%",
    position: "relative",
    width: 32,
    height: 32,
    [theme.breakpoints.down("desktop")]: { height: 28, width: 28 },
    overflow: "hidden",
  },
  textContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default ClinicianBadge;
